import isSubDirMode from './isSubDirMode';

const basePath = isSubDirMode ? ':subdirectory?/*' : '/*';

export default basePath;
